import { render, staticRenderFns } from "./MathiosstoneLogo.vue?vue&type=template&id=2db4edf2&scoped=true&"
var script = {}
import style0 from "./MathiosstoneLogo.vue?vue&type=style&index=0&id=2db4edf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4edf2",
  null
  
)

export default component.exports